import React from "react";
import { Transfer, Form } from "antd";
import { Controller } from "react-hook-form";
import { getError } from "../../../utils/form";

const ControlledTransfer = ({
  control,
  errors,
  name,
  label,
  required,
  data,
}) => {
  const error = getError({ errors, name });
  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { value, ...rest } }) => (
        <Form.Item
          label={label}
          required={required}
          labelAlign="left"
          validateStatus={error ? "error" : "success"}
          help={error?.message}
        >
          <Transfer
            {...rest}
            dataSource={data}
            titles={["Available Addresss", "Assigned Address"]}
            targetKeys={value}
            render={(item) => item.title}
            oneWay={false}
            style={{ marginBottom: 16 }}
            listStyle={{
              width: 500,
              height: 240,
            }}
          />
        </Form.Item>
      )}
    />
  );
};

export default ControlledTransfer;
